module.exports = __webpack_public_path__ + "img/Argentine-Antarctica.5141d76a.png";